import React from 'react';

import UserSidebar from '../../components/Elements/Sidebars/UserSidebar'
import Footer from '../../components/Sections/Footer';
export default function Userdashboard() {
  return (
<>
{/* <Slider/> */}
<UserSidebar/>


<Footer/>
</>
  )
}
